import React, { Component, Fragment } from 'react';

export const AccordionPanel = (props) => props;

export class Accordion extends Component {
    constructor(props) {
        super(props);
        const { index = -1 } = props;
        this.state = {
            index,
        };
    }
    handleClick(e, index) {
        this.setState((prevState, props) => ({
            ...prevState,
            index: index === prevState.index ? -1 : index,
        }));
    }
    render() {
        const accordions = React.Children.toArray(this.props.children);
        const activeClass = index => this.state.index === index ? 'active' : '';
        const headers = accordions.map((accordion, index) =>
            <Fragment  key={`accordion__header-${index}-${accordion.props.header}`}>
                {accordion.props.children.props.subNavigation != null ?
                    accordion.props.children.props.subNavigation[0].links.length > 0 &&
                    <div className="columns mobile-filter-btn">
                        <div className={`accordion__header ${activeClass(index)} ${accordion.props.icon || ''}`} onClick={e => this.handleClick(e, index)}>
                            {accordion.props.header || ''}
                        </div>
                    </div>
                    :
                    <div className="columns mobile-filter-btn">
                        <div className={`accordion__header ${activeClass(index)} ${accordion.props.icon || ''}`} onClick={e => this.handleClick(e, index)}>
                            {accordion.props.header || ''}
                        </div>
                    </div>
                }
            </Fragment>

        );
        const panels = accordions.map((accordion, index) =>
            <div className={`accordion__panel ${activeClass(index)}`} key={`accordion__panel-${index}-${accordion.props.header}`} >
                {accordion.props.children}
            </div>
        );
        return (
            <div className={this.props.className}>
                <nav className={`accordion__header-container`}>
                    {headers}
                </nav>
                {panels}
            </div>
        );
    }
}